module.exports = __webpack_public_path__ + "img/57e4c4ecda882fc2f696b49c6aade6c8.svg";